'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 200%;\n  height: 100%;\n  display: flex;\n  margin-left: ', ';\n  ', ';\n'], ['\n  width: 200%;\n  height: 100%;\n  display: flex;\n  margin-left: ', ';\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Content = _styledComponents2.default.div(_templateObject, function (_ref) {
  var on = _ref.on;
  return !!on ? '-100%' : 'none';
}, (0, _polished.transitions)('margin-left .2s ease-in-out'));

exports.default = Content;